import { createRoutine } from 'redux-saga-routines';

export const clearAlertUserData = createRoutine('CLEAR_ALERT_USER_DATA');
export const fetchAlertUser = createRoutine('ALERT_USER_FETCH');
export const saveAlertUserImage = createRoutine('SAVE_ALERT_USER_IMAGE');
export const saveAlertUserName = createRoutine('SAVE_ALERT_USER_NAME');
export const setAlertUserImage = createRoutine('ALERT_USER_IMAGE_SET');
export const setAlertUserName = createRoutine('ALERT_USER_SET_NAME');
export const setInitialSettings = createRoutine('SET_INITIAL_SETTINGS');
export const stopSyncingAlertUser = createRoutine('ALERT_USER_STOP_SYNC');
export const removeAlertUserAvatar = createRoutine('REMOVE_ALERT_USER_AVATAR');
